module.exports = __webpack_public_path__ + "img/couponNewBg.628bc22b.png";